<div
    class="w-full flex flex-col h-96 divide-y divide-gray-100 dark:divide-white/10 overflow-hidden shadow-card-container-pale">
    <div class="shrink-0 p-2 flex flex-row flex-wrap items-center justify-between gap-2">
        <div class="flex min-w-0 items-center flex-1">
            <div class="shrink-0">
                <div
                    class="relative size-10 rounded-xl bg-fuchsia-500/20 text-fuchsia-500 text-sm font-semibold flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6">
                        <path
                            d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z" />
                    </svg>

                    @if (getStreamService.totalUnreadCount() > 0) {
                    <span
                        class="absolute -mt-2 -mr-2 top-0 right-0 bg-pink-500 text-white text-xs px-1.5 py-0.5 rounded-full">{{
                        getStreamService.totalUnreadCount() }}</span>
                    }
                </div>

            </div>
            <div class="ml-4 min-w-0">
                <h3 class="text-md font-semibold text-primary">Un-Read Messages</h3>
                <p class="hidden text-sm text-secondary sm:block">
                    Messages you've received that you haven't read yet.
                </p>
            </div>
        </div>

        <button routerLink="/inbox" type="button"
            class="shrink-0 secondary-button text-secondary inline-flex flex-row items-center gap-x-2">Go
            to Inbox
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-5 text-secondary">
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
            </svg>
        </button>
    </div>
    <div class="flex-1 flex flex-col px-2 py-2 overflow-y-auto max-h-full">
        @if (getStreamService.channelsLoadFailed()) {
        <div class="w-full flex flex-col items-center justify-center p-4 h-full">
            <div class="text-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="mx-auto size-12 text-red-400 dark:text-red-500">
                    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                    <path d="M12 9v4" />
                    <path d="M12 17h.01" />
                </svg>
                <h3 class="mt-2 text-sm font-semibold text-primary">Couldn't load messages</h3>
                <p class="mt-1 text-sm text-secondary">Something went wrong. Please try again.</p>
                <button type="button" (click)="retry()"
                    class="secondary-button text-secondary mt-3 inline-flex flex-row items-center gap-x-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5 text-secondary">
                        <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
                        <path d="M21 3v5h-5" />
                        <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
                        <path d="M8 16H3v5" />
                    </svg>
                    Retry
                </button>
            </div>
        </div>
        } @else if (getStreamService.allChannels() === undefined) {
        <ul class="flex flex-col divide-y divide-gray-100 dark:divide-white/10" aria-hidden="true">
            @for (row of skeletonRows; track row) {
            <li class="relative overflow-hidden flex flex-row items-center gap-x-3 px-2 py-2.5">
                <div class="min-w-0 flex-1 space-y-2">
                    <div class="h-3 w-1/2 rounded-full bg-gray-200 dark:bg-white/10"></div>
                    <div class="h-2 w-3/4 rounded-full bg-gray-200 dark:bg-white/10"></div>
                </div>
                <div class="shrink-0 size-5 rounded-full bg-gray-200 dark:bg-white/10"></div>
                <div class="skeleton-shimmer"></div>
            </li>
            }
        </ul>
        } @else if (getStreamService.unreadChannels().length === 0) {
        <div class="w-full flex flex-col items-center justify-center p-4 h-full">
            <div class="text-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="mx-auto size-12 text-gray-400 dark:text-gray-500">
                    <path
                        d="M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z" />
                    <path d="m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10" />
                </svg>
                <h3 class="mt-2 text-sm font-semibold text-primary">No unread messages</h3>
                <p class="mt-1 text-sm text-secondary">You're all caught up!</p>
            </div>
        </div>
        } @else {
        <ul class="flex flex-col divide-y divide-gray-100 dark:divide-white/10">
            @for (channel of getStreamService.unreadChannels(); track channel.cid) {
            <li>
                <button type="button" (click)="openChannel(channel)"
                    class="w-full text-left flex flex-row items-center gap-x-3 px-2 py-2.5 rounded-lg hover:bg-gray-50 dark:hover:bg-white/5 transition-colors">
                    <div class="min-w-0 flex-1">
                        <p class="text-sm font-semibold text-primary truncate">
                            {{ channel.data?.name || 'Conversation' }}
                        </p>
                        <p class="text-xs text-secondary truncate">
                            {{ channel.state?.latestMessages?.at(-1)?.text || 'No messages yet' }}
                        </p>
                    </div>
                    <span
                        class="shrink-0 inline-flex items-center justify-center min-w-5 h-5 px-1.5 bg-pink-500 text-white text-xs font-semibold rounded-full">
                        {{ channel.countUnread() }}
                    </span>
                </button>
            </li>
            }
        </ul>
        }
    </div>
</div>